import { render, staticRenderFns } from "./OsirixIcon.vue?vue&type=template&id=3f70b509&"
import script from "./OsirixIcon.vue?vue&type=script&lang=js&"
export * from "./OsirixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports